function changeMap(e) {
    event.preventDefault();
    var newUrl = e.getAttribute("href");
    var mapFrame = document.getElementById("maps-banner");
    var mapTop = document.getElementById("maps-top");
    mapFrame.src = newUrl;
    mapTop.scrollIntoView();
}

require('./sticky-menu');
require('./counter');

import $ from 'jquery';

window.$ = window.jQuery = $;
import 'slick-carousel'
import Chocolat from 'chocolat'

window.mediaLightbox = Chocolat(document.querySelectorAll('.media-lightbox'), {
    // options here
})

window.mapsLightbox = Chocolat(document.querySelectorAll('.maps-lightbox'), {
    // options here
})

window.videosLightbox = Chocolat(document.querySelectorAll('.videos-lightbox'), {
    // options here
})

require('./image-slider.js');

$('.usp-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.usp-slider-large').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.review-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.single-review-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});


// change select placeholder color
$('select.input-lg').change(function () {
    if (!$(this).find(":selected").val()) {
        $(this).addClass('text-placeholder').removeClass('text-grey');
    } else {
        $(this).removeClass('text-placeholder').addClass('text-grey');
    }
});

$('.news-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

jQuery(function ($) {
    $(".mobile-menu-toggle").click(function () {
        var panel = $("#mobileMenu .slide-panel");
        var overlay = $("#mobileMenu .slide-background");

        if (!panel.hasClass('open')) {
            $("#mobileMenu").removeClass('hidden');
            setTimeout(function () {
                panel.toggleClass('translate-x-full open')
                overlay.toggleClass('opacity-0');
            }, 10);

            $('body').addClass('menu-open-body-overflow');
        } else {
            panel.toggleClass('translate-x-full open')
            overlay.toggleClass('opacity-0');

            setTimeout(function () {
                if (!panel.hasClass('open')) {
                    $("#mobileMenu").toggleClass('hidden')
                }
            }, 750);

            $('body').removeClass('menu-open-body-overflow');
        }
    });

    $('.media-lightbox-open').on('click', function () {
        window.mediaLightbox.api.open();
    });

    $('.maps-lightbox-open').on('click', function () {
        window.mapsLightbox.api.open();
    });

    $('.videos-lightbox-open').on('click', function () {
        window.videosLightbox.api.open();
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let lazyImages = [].slice.call(document.querySelectorAll(".lazy-load"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    if (lazyImage.nodeName.toLowerCase() === "div") {
                        lazyImage.style.backgroundImage = 'url("' + lazyImage.dataset.src + '")';
                    } else {
                        lazyImage.src = lazyImage.dataset.src;
                    }

                    lazyImage.classList.remove("lazy-load");
                    lazyImageObserver.unobserve(lazyImage);

                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
    let h2Elements = document.querySelectorAll('h2')
    h2Elements.forEach(function (element) {
        let computedStyle = window.getComputedStyle(element);
        if (computedStyle.textAlign === "center") {
            element.classList.add("centered-title");
        }
    });
});

// Back to top
$(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    let width = $(window).width();

    if (width < 768) {
        if (scrollTop > 100) {
            $('.back-to-top-link').fadeIn();
        } else {
            $('.back-to-top-link').fadeOut();
        }
    } else {
        $('.back-to-top-link').hide();
    }

});

$('.site-popup').each(function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId && document.cookie.indexOf("popup_" + popupId + "_hidden=") > -1) {
        $(this).remove();
    }
});


$('.close-site-popup').on('click', function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId) {
        document.cookie = "popup_" + popupId + "_hidden=yes;"
        $('.site-popup-' + popupId).remove();
    }

});


$("figure img").parent().addClass('bg-after-block');

$('#search-form-page-2-submit').click(function (event) {
    var places = $("#form-input-places option").map(function () {
        return this.value;
    }).get().join(",");

    var areas = $("#form-input-areas option").map(function () {
        return this.value;
    }).get().join(",");

    if (places === "" && areas === "") {
        event.preventDefault();
        var parent = document.getElementById('search-form-page-2-submit').parentNode;

        var tag = document.createElement('p');
        tag.classList = 'px-4 py-3 relative mb-4 font-bold';

        var text = document.createTextNode('Selecteer ten minste één plaats of gebied');
        tag.appendChild(text);
        parent.appendChild(tag);
    }
});

window.switchFaPlusMinus = function (element) {
    let faPlusElements = element.getElementsByClassName("fa-plus");
    for (let i = 0; i < faPlusElements.length; i++) {
        faPlusElements[i].classList.toggle('hidden');
    }

    let faMinElements = element.getElementsByClassName("fa-minus");
    for (let i = 0; i < faMinElements.length; i++) {
        faMinElements[i].classList.toggle('hidden');
    }
}
